/* eslint-disable import/prefer-default-export */
import { takeLatest, put } from 'redux-saga/effects' // eslint-disable-line
import { goBack } from 'connected-react-router'
import editReferencesActions, {
    editReferenceTypes,
} from '../../../redux/referencial/editReferencial'
import getAllReferencesActions from '../../../redux/referencial/getAllReferencial'
import getDisabledReferencesActions from '../../../redux/referencial/getDisabledReferenciel'
import { Put } from '../../../serveur/axios'
import alertActions from '../../../redux/alert'

function* editReferencialSagas({ response }) {
    try {
        const responseEdit = yield Put(`referenciel/${response.id}`, {
            ...response,
            enable: response.enable.toString(),
        })
        if (
            responseEdit.status === 200 ||
            responseEdit.status === 201 ||
            responseEdit.status === 202
        ) {
            yield put(
                editReferencesActions.editReferenceSuccess(responseEdit.data)
            )
            yield put(getAllReferencesActions.getAllReferenceRequest())
            yield put(
                getDisabledReferencesActions.getDisabledReferenceRequest(
                    '?enable=true'
                )
            )
            if (responseEdit.data) {
                yield put(
                    alertActions.alertShow(true, {
                        onConfirm: null,
                        warning: false,
                        info: false,
                        error: false,
                        success: true,
                        message: response.intl.formatMessage({
                            id: 'successSagaMessage',
                        }),
                        title: response.intl.formatMessage({
                            id: 'successSagaTitle',
                        }),
                    })
                )
            }
            yield put(goBack())
        } else {
            yield put(
                editReferencesActions.editReferenceFailure(responseEdit.data)
            )
        }
    } catch (error) {
        yield put(editReferencesActions.editReferenceFailure(error))
    }
}

export function* editReferencialSaga() {
    yield takeLatest(
        editReferenceTypes.EDIT_REFERENCE_REQUEST,
        editReferencialSagas
    )
}
